import React from 'react';

export default function Intro(){
    return(
        <section id="intro">
            <div className="contain">
                <p>Es una herramienta de visualización que permite presentar los resultados de la información de los contratos de infraestructura de transporte. Permite realizar análisis de tendencias, comparativos y proyecciones de los intervalos de confianza en diversos escenarios para los países de la región. Analiza variables como monto total, plazo, estado de ejecución, tipo de contrato, monto desembolsado, entre otras.</p>
            </div>
        </section>
    );
}